import { Modal } from "@/utils/bootstrap";
import SvgModalClose from "../../lib/SvgModalClose";
import CustomButton, {
  BtnRadius,
  BtnSizes,
  BtnTypes,
} from "../../lib/CustomButton";
import SvgErrIcon from "./SvgErrIcon";
import { useTranslation } from "@/hooks/localization/useTranslations";

interface Props {
  errors: string[];
  setErrors: (errors: string[]) => void;
}
const NotFieldErrModal: React.FC<Props> = ({ errors, setErrors }) => {
  const t = useTranslation();
  const onHide = () => setErrors([]);
  return (
    <Modal
      centered
      backdrop="static"
      show={errors.length > 0}
      onHide={onHide}
      dialogClassName="messagebox-dialog"
      contentClassName="messagebox-cart-disabled"
    >
      <div className="messagebox-closeicon">
        <SvgModalClose onClick={onHide} />
      </div>
      <div className="messagebox-title">
        <SvgErrIcon />
        {t.sorry}
      </div>
      <div className="message-err w-100">
        <>
          {errors.length === 1 ? (
            <div className="text-center">{errors[0]}</div>
          ) : (
            errors?.map((err, key) => <div key={key}>{`- ${err}`}</div>)
          )}
        </>
      </div>
      <CustomButton
        type={BtnTypes.primary}
        size={BtnSizes.small}
        radius={BtnRadius.small}
        onClick={onHide}
      >
        {t.close}
      </CustomButton>
    </Modal>
  );
};

export default NotFieldErrModal;
